// https://vuex.vuejs.org/en/getters.html

export default {
    events(state) {
      return state.events;
    },
    weekPlan(state){
      return state.weekPlan;
    },
    order(state){
      return state.order
    },    
    reservations(state){
      return state.reservations
    },
    openReservations(state){
      return state.open_reservation
    }
  };
  